module.exports = __webpack_public_path__ + "img/logo_8.63beb862.png";